import { StructuredText } from 'vue-datocms'

import ArrowDownIcon from '~/assets/images/arrow-down.svg?inline'


export default {
  __name: 'faq-item',
  props: {
  answer: {
    type: Object,
    required: true,
  },
  question: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return { __sfc: true,StructuredText, ArrowDownIcon }
}

}